import React from "react";
import { cn } from "@/lib/utils";

const TONES = {
  neutral: "bg-muted text-muted-foreground border-border",
  primary: "bg-primary-soft text-primary border-primary/20",
  success: "bg-success-soft text-success border-success/25",
  warning: "bg-warning-soft text-warning border-warning/30",
  danger: "bg-destructive-soft text-destructive border-destructive/25",
  info: "bg-info-soft text-info border-info/25",
};

const MAP = {
  "New Inquiry": "info", Contacted: "info", "Follow-up Required": "warning",
  Interested: "primary", "Quotation Created": "primary", Negotiation: "warning",
  "Proforma Invoice Created": "primary", "Invoice Created": "success",
  Converted: "success", Lost: "danger", "On Hold": "neutral",
  Draft: "neutral", Sent: "info", Accepted: "success", Rejected: "danger",
  Expired: "danger", "Converted to Proforma Invoice": "success",
  "Payment Pending": "warning", "Partially Paid": "warning", Paid: "success",
  "Converted to Invoice": "success", Cancelled: "danger", Unpaid: "warning",
  Overdue: "danger", Approved: "success", "Partially Received": "warning",
  "Fully Received": "success", Scheduled: "info", Completed: "success",
  Missed: "danger", Active: "success", Inactive: "neutral",
  admin: "primary", sales: "info", telecaller: "warning", staff: "neutral",
};

export const StatusBadge = ({ status, tone, className, dot = true }) => {
  const t = tone || MAP[status] || "neutral";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        TONES[t],
        className
      )}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />}
      {status}
    </span>
  );
};
